import { FormControl, FormItem, FormMessage, Input } from '@uturn/ui-kit';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const TextInput = ({
	field,
	placeholder = 'New value',
	id,
}: {
	field: ControllerRenderProps<FieldValues, string>;
	placeholder?: string;
	id?: string;
}) => {
	const asString = (v: unknown) => (typeof v === 'string' ? v : '');

	return (
		<FormItem>
			<FormControl>
				<Input
					id={id}
					placeholder={placeholder}
					value={asString(field.value)}
					onChange={field.onChange}
				/>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
